import { NodeKind, TransformKind } from '@/core/document'
import { integerRectInside, orientationCropBounds, type Rect } from '@/core/geometry'
import { EditAction } from '@/core/history'
import { useEditSession } from '@/core/store/editSession'
import { selectEffectiveRatio, selectSelectedSource } from '@/core/store/selectors'
import { cropRectForZoom } from '@/tools/crop/gestures/frameMath'
import { selectSelectedCrop, selectSelectedImageNode } from '@/tools/crop/selectors'
import { selectSelectedOrientation } from '@/tools/orientation/selectors'

export function updateSelectedCrop(rect: Rect, commit = false): void {
  const state = useEditSession.getState()
  const node = selectSelectedImageNode(state)
  state.updateNode(node.id, (current) => {
    if (current.kind !== NodeKind.Image) throw new Error('Crop update target changed node kind')
    return {
      ...current,
      transforms: { ...current.transforms, [TransformKind.Crop]: { rect } },
    }
  })
  if (commit) useEditSession.getState().commitHistory(EditAction.CropPhoto)
}

export function setSelectedCropZoom(zoom: number, commit = false): void {
  const state = useEditSession.getState()
  const source = selectSelectedSource(state)
  const orientation = selectSelectedOrientation(state)
  const bounds = integerRectInside(orientationCropBounds(source, orientation))
  const crop = selectSelectedCrop(state)
  const ratio = selectEffectiveRatio(state)
  updateSelectedCrop(cropRectForZoom(crop.rect, zoom, bounds, ratio), commit)
}

export function resetSelectedCrop(): void {
  const state = useEditSession.getState()
  const source = selectSelectedSource(state)
  const orientation = selectSelectedOrientation(state)
  const bounds = integerRectInside(orientationCropBounds(source, orientation))
  const ratio = selectEffectiveRatio(state)
  const crop = selectSelectedCrop(state)
  updateSelectedCrop(cropRectForZoom(crop.rect, 1, bounds, ratio), true)
}
